import React, { FC, ReactNode } from 'react';

interface LinkButtonProps {
	onClick: () => void;
	children?: ReactNode;
	className?: string;
	ariaLabel?: string;
	disabled?: boolean;
}

export const LinkButton: FC<LinkButtonProps> = ({ onClick, children, className, ariaLabel, disabled }) => {
	return (
		<button
			type="button"
			className={`link-button ${className ?? ''}`}
			onClick={onClick}
			aria-label={ariaLabel}
			disabled={disabled}
		>
			{children}
		</button>
	);
};

export default LinkButton;
